export default __webpack_public_path__ + "static/media/projects.90e82905.PNG";